import { default as React } from "react";

import { WithTranslation, withTranslation } from "react-i18next";
import Row from "./row";
import { MonitoringDto } from "core/backend/common";
import { ApplicationState } from "core/app";

interface OwnProps {
    scrollPosition?: { left: number, top: number };
    data: MonitoringDto[];
    applicationState: ApplicationState;
}

const List = ({ t, applicationState, data, scrollPosition }: OwnProps & WithTranslation) => {
    const top = Math.max(0, ((scrollPosition?.top || 0) - 16));
    const left = Math.max(0, ((scrollPosition?.left || 0) - 16));
	const pageList = applicationState.pages.map(p => p.config);
    
    return (
        <table id="datatable">
            <thead>
                <tr>
                    <th className="fixedDateColumn" style={{ top: top + "px", left: left + "px" }}>{t("common:Date")}</th>
                    <th className="fixedHeader" style={{ top: top + "px", left: left + "px" }}>{t("monitoring:page")}</th>
                    <th className="fixedHeader" style={{ top: top + "px", left: left + "px" }}>{t("monitoring:status")}</th>
                    <th className="fixedHeader" style={{ top: top + "px", left: left + "px" }}>{t("monitoring:followUpAction")}</th>
                </tr>
            </thead>
            <tbody>
                {
                    data && data.sort((a, b) =>
                        pageList.findIndex(x => t(x.menu).toLowerCase() == a.page.toLowerCase() || t(x.title).toLowerCase() == a.page.toLowerCase()) <=
                            pageList.findIndex(x => t(x.menu).toLowerCase() == b.page.toLowerCase() || t(x.title).toLowerCase() == b.page.toLowerCase()) ? -1 : 1
                    ).map((d) => <Row key={d.id} dto={d} left={left} />)
                }
            </tbody>
        </table>
    );
};

const translated = withTranslation("monitoring")(List);

export default translated;